import { Component, Input, Output, EventEmitter } from "@angular/core";

@Component({
    selector: "person-selector",
    template: require('./person-selector.component.html'),
    styles: [require('./person-selector.component.css')]
})
export class PersonSelectorComponent {

    selected: Nema.Crew.Model.Person[];

    _persons: Nema.Crew.Model.Person[];

    @Input()
    get persons(): Nema.Crew.Model.Person[] {
        return this._persons;
    }

    set persons(val) {
        this._persons = val;
        this.selectedPersons = [];
    }

    @Input()
    get selectedPersons() {
        return this.selected;
    }

    set selectedPersons(val) {
        this.selected = val;
        this.selectedPersonsChange.emit(this.selected);
    }

    @Output()
    selectedPersonsChange = new EventEmitter();

    @Input()
    selectedActivity: Nema.Crew.Model.Activity;

    @Input()
    canRegisterActivity: boolean;

    @Input()
    workgroups: Nema.Crew.Model.WorkGroup[];

    @Input()
    isLoading = false;

    @Input()
    isFetching = false;

    @Output()
    registerActivities = new EventEmitter();

    onRegisterActivities() {
        this.registerActivities.emit();
    }

    searchText: string;

    workgroup: Nema.Crew.Model.WorkGroup;

    get selectedWorkgroup() {
        return this.workgroup;
    }

    set selectedWorkgroup(val) {
        this.workgroup = val;

        if (!this.workgroup) {
            this.selectedPersons = [];
            return;
        }

        this.selectedPersons = this.persons.filter((person: Nema.Crew.Model.Person) => {
            return !!this.workgroup
                .WorkGroupPersons
                .find((workgroupPerson: Nema.Crew.Model.WorkGroupPerson) => workgroupPerson.PersonId === person.Id);
        });
    }

    resetFilter() {
        this.selectedWorkgroup = null;
        this.selectedPersons = [];
        this.searchText = '';
    }

    getSelectionText(): string {

        let res = `${this.persons.length} person(s) in total`;

        if (this.selectedPersons && this.selectedPersons.length === 1) {
            res = `${this.selectedPersons.length} person selected - ${this.persons.length} in total`;
        } else if (this.selectedPersons && this.selectedPersons.length > 1) {
            res = `${this.selectedPersons.length} persons selected - ${this.persons.length} in total`;
        }

        return res;
    }

    isDuplicatePersonName(person: Nema.Crew.Model.Person, persons: Nema.Crew.Model.Person[]): boolean {
        return persons.filter(x => x.Name === person.Name).length > 1;
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/activities/daily-activities/person-selector.component.ts